import { Injectable, signal, WritableSignal } from '@angular/core';
import { LinkInformation } from '../interfaces/link-information';
import { Payment } from '../interfaces/payment';

@Injectable({
  providedIn: 'root'
})
export class LinkService {

  private linkInformation = signal<LinkInformation>({})

  private paymentMethod = '';

  private paymentNumber = '';

  private payment: WritableSignal<Payment> = signal<Payment>({});


  setLinkInformation(linkInfo: LinkInformation){
    this.linkInformation.set(linkInfo);
  }

  setPaymentInput(paymentMethod: string, paymentNumber: string){
    this.paymentMethod = paymentMethod
    this.paymentNumber = paymentNumber
  }

  // setPaymentResult(payment: Payment){
  //   this.payment.set(payment)
  // }

  public getLinkInformation(): LinkInformation{
    return this.linkInformation()
  }
  
  public getPaymentMethod(): string{
    return this.paymentMethod;
  }

  public getPaymentNumber(): string{
    return this.paymentNumber;
  }

  public getPayment(){
    return this.payment();
  }


  clear():void{
    this.payment.set({});
    this.paymentNumber = '';
    this.paymentMethod = '';
    this.linkInformation.set({});
  }

  constructor() { }
}
